import {autoserialize} from "cerialize";
import ErrorContent from "@/ts/interfaces/ErrorContent";

export default class Error {
    @autoserialize public message: ErrorContent;

    constructor(message: ErrorContent) {
        this.message = message;
    }
}


